function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.6341 7.99999C33.6341 7.99999 2.03164 8 1.3659 8C0.700161 8 0.138603 7.53381 0.0560304 6.91259L1.3659 6.75862C0.0560304 6.91259 0.0560304 6.91259 0.0560304 6.91259L0.0557595 6.91056L0.0554276 6.90801L0.054577 6.90137L0.0522004 6.88206C0.0503388 6.86656 0.0479508 6.84582 0.0452272 6.82018C0.039776 6.76894 0.0329515 6.69795 0.0262719 6.61C0.0129434 6.43449 1.58312e-07 6.18912 1.83889e-07 5.89655C2.34346e-07 5.31939 0.0501674 4.52054 0.268589 3.69892C0.485016 2.88482 0.890488 1.95874 1.67003 1.22566C2.4838 0.4604 3.60615 2.02383e-06 5.03274 2.14855e-06L29.9673 2.42105e-06C31.3938 2.54576e-06 32.5162 0.460399 33.33 1.22566C34.1095 1.95874 34.515 2.88481 34.7314 3.69891C34.9498 4.52053 35 5.31938 35 5.89654C35 6.18911 34.9871 6.43447 34.9737 6.60998C34.967 6.69794 34.9602 6.76893 34.9548 6.82017C34.9521 6.8458 34.9497 6.86655 34.9478 6.88205L34.9454 6.90136L34.9446 6.90799L34.9442 6.91055C34.9442 6.91055 34.944 6.91258 33.6341 6.75861L34.944 6.91258C34.8614 7.5338 34.2998 7.99999 33.6341 7.99999ZM32.3503 5.51723C32.3311 5.13878 32.2798 4.7137 32.1701 4.30107C32.0198 3.73587 31.7836 3.28264 31.4631 2.98123C31.1768 2.71201 30.7408 2.48276 29.9673 2.48276L5.03274 2.48276C4.25922 2.48276 3.82317 2.71201 3.53688 2.98123C3.21638 3.28264 2.98015 3.73587 2.82989 4.30108C2.7202 4.7137 2.66894 5.13879 2.6497 5.51724L32.3503 5.51723Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35 14L0 14L6.99382e-07 6L35 6L35 14Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.5 23C22.6716 23 22 22.4124 22 21.6875L22 17.3125C22 16.5876 22.6716 16 23.5 16C24.3284 16 25 16.5876 25 17.3125L25 21.6875C25 22.4124 24.3284 23 23.5 23Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 23C10.6716 23 10 22.4124 10 21.6875L10 17.3125C10 16.5876 10.6716 16 11.5 16C12.3284 16 13 16.5876 13 17.3125L13 21.6875C13 22.4124 12.3284 23 11.5 23Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 26C16.6716 26 16 25.4124 16 24.6875L16 20.3125C16 19.5876 16.6716 19 17.5 19C18.3284 19 19 19.5876 19 20.3125L19 24.6875C19 25.4124 18.3284 26 17.5 26Z",
  fill: "black"
});

var SvgAirConditioning = function SvgAirConditioning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirConditioning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/air-conditioning.7965f244.svg";
export { ForwardRef as ReactComponent };